<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-form ref="form" @submit.prevent="onSubmit">
        <v-card-title class="headline">{{ buttonTxt }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="section.name"
            label="Section Name"
            :rules="[rules.required]"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="emit('entrySectionCancled')">Cancel</v-btn>
          <v-btn type="submit" color="primary">{{ buttonTxt }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { EntryDTO, EntrySectionDTO, IEntrySectionDTO } from '@/dtos';
import { useEntryStore, useUpdateStatusStore } from '@/stores';
import { SNACKSTATUS } from '@/stores/util';
import { rules } from '@/helpers';

const props = defineProps<{
  entry: EntryDTO;
  show: boolean;
  yearId: string;
  isAdd: boolean;
  section?: IEntrySectionDTO;
}>();
const entry = computed(() => props.entry);
const yearId = computed(() => props.yearId);
const isAdd = computed(() => props.isAdd);
const buttonTxt = computed(() => (isAdd.value ? 'Add Section' : 'Update Section'));
const emit = defineEmits(['snack', 'entrySectionSaved', 'entrySectionCancled']);
const show = computed(() => props.show);
const section = ref<IEntrySectionDTO>(new EntrySectionDTO());
const entryStore = useEntryStore();
const statusStore = useUpdateStatusStore();
watch(
  () => props.section,
  () => {
    if (props.section) {
      section.value = new EntrySectionDTO(props.section);
    } else {
      section.value = new EntrySectionDTO();
    }
  },
  { immediate: true },
);
const onSubmit = () => {
  if (!section.value.entry || !section.value.entry.id) {
    section.value.entry = new EntryDTO();
    section.value.entry.id = entry.value.id;
  }
  if (isAdd.value) {
    entryStore.createSection.mutateAsync({ section: section.value, yearId: yearId.value });
  } else {
    entryStore.updateSection.mutateAsync({
      section: section.value,
      yearId: yearId.value,
      entryId: entry.value.id,
    });
  }
};

watch(
  () => statusStore.getStatus(`entry-section-create`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    const key = `entry-section-create`;
    emit('snack', 'Section', value, statusStore.getError(key));
    emit('entrySectionSaved');
  },
);

const key = computed(() => `entry-section-update-${section.value.id}`);
watch(
  () => statusStore.getStatus(key.value),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    emit('snack', 'Section', value, statusStore.getError(key.value));
    emit('entrySectionSaved');
  },
);
</script>
